export default {
  cta: "Producing ajustments",
  title: "Overview of operations",
  leftTitle: "Hurray!",
  leftSubtitle: "Let's proceed with these 3 operations"
};
